import React from "react";
import { makeStyles, Box, Container } from "@material-ui/core";
import Page from "../components/Page";
import ResetConfirmPasswordContainer from "../containers/auth/ResetConfirmPasswordContainer";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(0),
    },
  },
}));

const ResetConfirmPage = () => {
  const classes = useStyles();
  let { type, uid, token } = useParams();
  const { t } = useTranslation();

  return (
    <Page className={classes.root} title="Ecat">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <ResetConfirmPasswordContainer
            type={type}
            uid={uid}
            token={token}
            message={t("reset_confirm.message")}
          />
        </Container>
      </Box>
    </Page>
  );
};

export default ResetConfirmPage;
